import Vue from 'vue';
import _ from 'lodash';
import { Player, builder, PlayerId } from '.';
import { Action } from '@/actions';

type PlayerJoined = {
    gid: string,
    player: {
        name: string,
        id: string
    },
    players: Player[],
    playerInfo?: {
        id: string,
        name: string,
        isOwner: boolean
    }
}

type NextTurn = {
    action: Action.nextTurn,
    turn: number,
    currentPlayerId: string,
    word?: string
}

export const commitPlayerJoined = builder.commit((state, data: PlayerJoined) => {
    state.players = data.players;
    if (data.playerInfo) {
        state.gid = data.gid;
        state.playerInfo = data.playerInfo;
        state.isOwner = data.playerInfo.isOwner;
    }
}, "commitPlayerJoined");

export const commitNextTurn = builder.commit((state, data: NextTurn) => {
    state.currentTurn.turn = data.turn;
    state.currentTurn.currentPlayerId = data.currentPlayerId;
    state.currentTurn.hints = {};
    state.currentTurn.playersWhoAddedHints = [];
    state.currentTurn.word = data.word;
}, "commitNextTurn");

export const commitHintAdded = builder.commit((state, { playerId }: { playerId: PlayerId }) => {
    state.currentTurn.playersWhoAddedHints.push(playerId);
}, "commitHintAdded");

export const commitShowHints = builder.commit((state, { hints }: { hints: { [pid: string]: string } }) => {
    state.currentTurn.hints = hints;
}, "commitShowHints");

export const commitRevealHints = builder.commit((state, { hints }: { hints: { [pid: string]: string } }) => {
    state.currentTurn.hints = hints;
}, "commitRevealHints");


